import { render, staticRenderFns } from "./ParticipantManagement.vue?vue&type=template&id=59458a9c"
import script from "./ParticipantManagement.vue?vue&type=script&lang=js"
export * from "./ParticipantManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports